import { LoanPayroll } from 'src/presentation/pages'

export const makeLoanPayroll = () => <LoanPayroll />
